export const FeatureFlag = {
  GUEST_LANDING_EXTENDED_CONTENT: 'guestLandingExtendedContent',
  GUEST_EVENTS_EXCLUDE_IMPORTED: 'guestEventsExcludeImported',
} as const;

export type FeatureFlagName = typeof FeatureFlag[keyof typeof FeatureFlag];

export type FeatureFlagsConfig = Record<FeatureFlagName, boolean>;
